module.exports = __webpack_public_path__ + "static/media/Accademia - White - 9946_9509_9355.f6f46317.jpg";